import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  CardFooter,
  CardHeader,
  CardBody,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import AWS from "../../../assets/images/AWS-logo.jpg";
import Azure from "../../../assets/images/Azure-Logo-PNG.png";
import GCP from "../../../assets/images/GCP-Logo.png";
import pushNotification from "../../../helperFunctions/pushNotification";
import { useAuthUserToken } from "../../../hooks/useAuthUserToken";
import { userurl1 } from "../../../helperFunctions/apiFunction";
import toast from "react-hot-toast";
import { decryptData } from "../../../utils/Encryption";

export default function Review({
  setStep,
  selectedProvider,
  scope,
  formDataAWS,
  formDataAzure,
  formDataGCP,
  uploadedJson,
}) {
  console.log("🚀 ~ formDataAWS:", formDataAWS, formDataAzure, formDataGCP);
  const { completeAuthData: authData } = useAuthUserToken();
  const [finalData, setFinalData] = useState();
  const [refreshToken, setRefreshToken] = useState();
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const notiData = {
      title: "Assets",
      description: `New ${selectedProvider} Integration added`,
    };

    if (refreshToken) {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${refreshToken}`,
        },
        body: JSON.stringify(finalData),
      };

      fetch(`${userurl1}collection/integrationdata`, requestOptions)
        .then((response) => response.text())
        .then((data) => {
          setRedirect(true);
          toast.success("Success");
        })
        .catch((error) => console.error("error", error));

      // Handle POST request for notification
      pushNotification(notiData, e, "notification", refreshToken);
    }
  };

  useEffect(() => {
    const Ldata = decryptData(localStorage.getItem("user_info"));
    if (Ldata) {
      const parsedData = Ldata;
      if (parsedData.refresh && parsedData.refresh.token) {
        const token = parsedData.refresh.token;
        setRefreshToken(token);
      } else {
        console.error("Refresh token not found in the data.");
      }
    } else {
      console.error("Data not found in localStorage.");
    }

    setFinalData(
      selectedProvider === "AWS"
        ? {
            integrationId: 1,
            clientId: authData?.clientId,
            integrationProvider: selectedProvider,
            integrationConfig: [
              {
                accountId: formDataAWS.accID,
                externalId: formDataAWS.externalId,
                defaultRegion: "us-east-1",
                integrationScope: scope,
                role: formDataAWS.role,
              },
            ],
            integrationTitle: formDataAWS.accname,
            integrationStatus: "Active",
            integrationCreationUser: "",
            integrationApprovalUser: "",
            integrationCreationTimestamp: "",
            integrationApprovalTimestamp: "",
          }
        : selectedProvider === "Azure"
        ? {
            integrationId: 2,
            clientId: authData?.clientId,
            integrationProvider: selectedProvider,
            integrationConfig: [
              {
                tenantId: formDataAzure.tenantID,
                subscriptionId: formDataAzure.subID,
                applicationId: formDataAzure.appID,
                secretKeyValue: formDataAzure.appClientSecret,
                integrationScope: scope,
              },
            ],
            integrationTitle: formDataAzure.accName,
            integrationStatus: "Active",
            integrationCreationUser: "",
            integrationApprovalUser: "",
            integrationCreationTimestamp: "",
            integrationApprovalTimestamp: "",
          }
        : selectedProvider === "GCP"
        ? {
            integrationId: 3,
            clientId: authData?.clientId,
            integrationProvider: selectedProvider,

            integrationConfig: [
              {
                type: scope,
                projectID: uploadedJson.prjID,
                project: "",
                clientEmail: uploadedJson.cliemail,
                privateKey: uploadedJson.privatekeyid,
                organizationId: uploadedJson.cliid,
              },
            ],
            integrationTitle: "",

            integrationStatus: "Active",
            integrationCreationUser: "",
            integrationApprovalUser: "",
            integrationCreationTimestamp: "",
            integrationApprovalTimestamp: "",

            accountName: formDataGCP.accname,
          }
        : ""
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (redirect) {
      navigate("/inventory/assets");
    }
  }, [redirect, navigate]);

  return (
    <>
      <div className="flex flex-col justify-center max-w-[900px] items-center w-full m-auto">
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="flex flex-col justify-center items-center mb-3.5 gap-4">
            <img
              src={
                selectedProvider === "AWS"
                  ? AWS
                  : selectedProvider === "Azure"
                  ? Azure
                  : selectedProvider === "GCP"
                  ? GCP
                  : ""
              }
              alt="Logo"
              className="w-20 h-auto rounded-md"
            />
            <Typography variant="h5" color="blue-gray">
              Review Status
            </Typography>
          </div>
        </CardHeader>

        <CardBody>
          <div className="text-left mb-4 w-full">
            <Typography
              variant="h6"
              color="blue-gray"
              className="mb-3.5 font-bold"
            >
              Review your account details
            </Typography>

            {selectedProvider === "AWS" ? (
              <>
                <div className="flex flex-col text-left w-full gap-4">
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Scope
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {scope}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Account Name
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAWS.accname}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Account ID
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAWS.accID}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      IAM Role ARN
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAWS.role}
                    </span>
                  </div>
                </div>
              </>
            ) : selectedProvider === "Azure" ? (
              <>
                <div className="flex flex-col text-left w-full gap-4">
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Scope
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {scope}
                    </span>
                  </div>

                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Account Name
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAzure.accname}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Tenant ID
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAzure.tenantID}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Subscription ID
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAzure.subID}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Applicaiton ID
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAzure.appID}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800 ml-2">
                      Client Secret
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataAzure.appClientSecret}
                    </span>
                  </div>
                </div>
              </>
            ) : selectedProvider === "GCP" ? (
              <>
                <div className="flex flex-col text-left w-full gap-4">
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800">
                      Scope
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {scope}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800">
                      Account Name
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataGCP.accname}
                    </span>
                  </div>
                  <div className="flex justify-between ">
                    <span className="font-bold text-base !text-blue-gray-800">
                      Project ID
                    </span>
                    <span className="font-bold text-base !text-blue-gray-700">
                      {formDataGCP.prjID}
                    </span>
                  </div>
                  {uploadedJson && (
                    <div>
                      {Object.keys(uploadedJson).map((key, index) => (
                        <div key={index} className="flex justify-between ">
                          <span className="font-bold text-base !text-blue-gray-800">
                            {key}:
                          </span>
                          <span>{uploadedJson[key]}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* </div> */}
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-col items-center w-full bg-white">
                  <img
                    height={250}
                    width={250}
                    quality={100}
                    src="/assets/images/no-data-found.png"
                    className="w-1/4 mix-blend-darken"
                    alt=""
                  />
                  <p className="text-[18px] font-extralight">
                    Something went wrong!
                  </p>
                </div>
              </>
            )}
          </div>
        </CardBody>
      </div>
      <CardFooter>
        <div className="mt-auto flex justify-end gap-4">
          <Button
            variant="gradient"
            color="light-blue"
            onClick={() => {
              setStep("Configure");
            }}
          >
            Previous
          </Button>
          <Button
            variant="gradient"
            color="green"
            style={{ marginRight: "1rem" }}
            onClick={handleSubmit}
          >
            Save
          </Button>

          <Button
            variant="text"
            color="red"
            onClick={() => {
              navigate("/inventory/assets");
            }}
          >
            Cancel
          </Button>
        </div>
      </CardFooter>
    </>
  );
}
